<div class="loading-overlay">
  <p-progress-spinner ariaLabel="loading" />
</div>
